import React from 'react';
import ReactMarkdown from 'react-markdown';
import { MarkdownProps } from '@dreamai/types';
import InboxViewComponentView from './InboxViewComponentView';
import './markdown-component.scss';
import { ReactComponent as EditIcon } from '../../../../icons/edit.svg';

export interface MarkdownComponentProps extends MarkdownProps {
  isInboxView?: boolean;
  onInboxViewComponentViewClick?: (componentId: string) => void;
}

export const MarkdownComponent: React.FC<MarkdownComponentProps> = ({
  title,
  content,
  isInboxView,
  onInboxViewComponentViewClick,
}) => {
  // If in inbox view, render the simplified card view
  if (isInboxView) {
    // Create subtitle from first 100 characters of content
    const subtitle =
      content.length > 100 ? content.substring(0, 100) + '...' : content;

    return (
      <InboxViewComponentView
        title={title}
        onClick={
          onInboxViewComponentViewClick
            ? () => onInboxViewComponentViewClick('markdown')
            : undefined
        }
      />
    );
  }

  // Full view - render the complete markdown component
  return (
    <div className='markdown-component'>
      <div className='markdown-component__header'>
        <h3 className='markdown-component__title'>{title}</h3>
      </div>
      <div className='markdown-component__content'>
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};
